import { useState } from "react";

const BlogHeader = ({ handleSearch }) => {
  const [search, setSearch] = useState("");

  return (
    <section
      className="relative overflow-hidden"
      style={{
        background:
          "linear-gradient(124deg, #fffdf8 0%, #fff9e9 62%, #f2f4ff 100%)",
        borderBottom: "1px solid #e5dfd3",
        minHeight: "330px",
      }}
    >
      <span
        aria-hidden="true"
        className="hidden lg:block absolute pointer-events-none select-none"
        style={{
          bottom: "-42px",
          right: "-18px",
          color: "#0507940b",
          letterSpacing: "-0.08em",
          fontFamily: "Georgia, serif",
          fontSize: "145px",
          fontWeight: 700,
        }}
      >
        JOURNAL
      </span>

      <div
        className="relative z-[1] mx-auto grid grid-cols-1 lg:grid-cols-12 items-center gap-8 lg:gap-[76px] px-[18px] sm:px-[26px] pt-10 pb-[35px] lg:py-[54px]"
        style={{ maxWidth: "1280px" }}
      >
        <div className="lg:col-span-8">
          <p
            className="flex items-center gap-3 text-primary"
            style={{
              letterSpacing: "0.11em",
              fontSize: "15px",
              fontWeight: 800,
              marginBottom: "14px",
            }}
          >
            <span
              aria-hidden="true"
              className="bg-secondary flex-none"
              style={{ width: "34px", height: "3px" }}
            />
            THE UTIVA JOURNAL
          </p>
          <h1
            className="text-primary"
            style={{
              maxWidth: "810px",
              letterSpacing: "-0.055em",
              margin: "0 0 17px",
              fontSize: "clamp(44px, 8.4vw, 68px)",
              lineHeight: 1.02,
            }}
          >
            Useful ideas for people building{" "}
            <em
              style={{
                color: "#20232d",
                fontFamily: "Georgia, serif",
                fontWeight: 500,
                fontStyle: "italic",
              }}
            >
              what comes next.
            </em>
          </h1>
          <p
            style={{
              maxWidth: "620px",
              color: "#5e6574",
              margin: 0,
              fontSize: "18px",
              lineHeight: 1.7,
            }}
          >
            Perspectives, stories and practical guides for learning, careers,
            business capability and global work.
          </p>
        </div>

        <div
          className="max-w-[720px] lg:col-span-4 lg:max-w-none"
          style={{
            background: "#ffffffe6",
            border: "1px solid #dfd7c5",
            borderRadius: "18px 18px 40px 18px",
            padding: "25px",
            boxShadow: "0 22px 60px #2d26151a",
          }}
        >
          <label
            htmlFor="blog-search"
            className="text-primary"
            style={{
              display: "block",
              marginBottom: "10px",
              fontSize: "16px",
              fontWeight: 800,
            }}
          >
            What do you want to read about?
          </label>
          <div
            className="flex items-center focus-within:border-primary"
            style={{
              background: "#fff",
              border: "2px solid #d7d5ce",
              borderRadius: "12px",
              gap: "11px",
              minHeight: "58px",
              padding: "0 16px",
            }}
          >
            <span
              aria-hidden="true"
              className="text-secondary flex-none"
              style={{ fontSize: "28px", transform: "rotate(-15deg)" }}
            >
              ⌕
            </span>
            <input
              id="blog-search"
              type="search"
              placeholder="Search careers, AI, teams..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyUp={(e) => handleSearch(e, search)}
              className="w-full min-w-0 bg-transparent border-0 outline-none"
              style={{ color: "#20232d", fontSize: "16px" }}
            />
          </div>
          <a
            href="#journal"
            className="text-primary inline-flex items-center"
            style={{
              gap: "8px",
              marginTop: "15px",
              fontSize: "15px",
              fontWeight: 800,
            }}
          >
            Browse the latest writing <span aria-hidden="true">↓</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default BlogHeader;
